import { getInventoryStrategy } from 'src/services/inventory/sales-restrictions/helpers'
import { reactive } from 'vue'

class AvailabilitiesAndConstraintsService {
  static #instance = null
  static #itemVariationAvailabilitiesAndConstraints = null
  static #modifierAvailabilitiesAndConstraints = null

  constructor () {
    if (!AvailabilitiesAndConstraintsService.#instance) {
      AvailabilitiesAndConstraintsService.#itemVariationAvailabilitiesAndConstraints = reactive({ data: null })
      AvailabilitiesAndConstraintsService.#modifierAvailabilitiesAndConstraints = reactive({ data: null })

      AvailabilitiesAndConstraintsService.#instance = this
    }
    return AvailabilitiesAndConstraintsService.#instance
  }

  isModelInventoriable (model) {
    switch (model.typeName) {
      case 'ItemVariation':
        return AvailabilitiesAndConstraintsService.#isItemVariationInventoriable(model)
      case 'Modifier':
        return AvailabilitiesAndConstraintsService.#isModifierInventoriable(model)
      case 'Item':
        return AvailabilitiesAndConstraintsService.#isItemInventoriable(model)
      case 'RegisterButton':
        switch (model.type) {
          case 'item':
            return AvailabilitiesAndConstraintsService.#isItemInventoriable(model.item)
          case 'item-variation':
            return AvailabilitiesAndConstraintsService.#isItemVariationInventoriable(model.itemVariation)
          default:
            return false
        }
      default:
        return false
    }
  }

  getAvailabilitiesAndConstraintsForModel (model, {
    deliveryType,
    item,
    screen
  }) {
    const inventoryStrategy = getInventoryStrategy()

    if (_.isNil(inventoryStrategy)) return null

    const sourceLocationKey = inventoryStrategy.sourceLocationKey({ deliveryType, item, screen })
    const sourceLocationId = inventoryStrategy.sourceLocationId({ deliveryType, item, screen })

    let result

    if (model.typeName === 'ItemVariation') {
      result = AvailabilitiesAndConstraintsService.#itemVariationAvailabilitiesAndConstraints?.data?.[model.id]?.[sourceLocationKey]?.[sourceLocationId]
    } else if (model.typeName === 'Modifier') {
      result = AvailabilitiesAndConstraintsService.#modifierAvailabilitiesAndConstraints?.data?.[model.id]?.[sourceLocationKey]?.[sourceLocationId]
    }

    return result
  }

  setItemVariationAvailabilitiesAndConstraints (itemVariationAvailabilitiesAndConstraints) {
    AvailabilitiesAndConstraintsService.#itemVariationAvailabilitiesAndConstraints.data = itemVariationAvailabilitiesAndConstraints
  }

  setModifierAvailabilitiesAndConstraints (modifierAvailabilitiesAndConstraints) {
    AvailabilitiesAndConstraintsService.#modifierAvailabilitiesAndConstraints.data = modifierAvailabilitiesAndConstraints
  }

  static #isItemVariationInventoriable (itemVariation) {
    return !_.isNil(AvailabilitiesAndConstraintsService.#itemVariationAvailabilitiesAndConstraints?.data?.[itemVariation.id])
  }

  static #isModifierInventoriable (modifier) {
    return !_.isNil(AvailabilitiesAndConstraintsService.#modifierAvailabilitiesAndConstraints?.data?.[modifier.id])
  }

  static #isItemInventoriable (item) {
    const hasInventoriableItemVariations = _(item.activeItemVariations)
      .filter('hasRecipe')
      .some(this.isItemVariationInventoriable)

    const hasInventoriableModifiers = _(item.itemModifierSets.data)
      .map('modifierSet.activeModifiers')
      .flatten()
      .filter('hasRecipe')
      .some(this.isModifierInventoriable)

    return hasInventoriableItemVariations || hasInventoriableModifiers
  }
}

const availabilitiesAndConstraintsService = new AvailabilitiesAndConstraintsService()
export default availabilitiesAndConstraintsService
